var _circle, _path, _path2, _rect, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 5,
    r: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9,16.43a1,1,0,0,0-.12-1L7,10.65V6h3.09A5.36,5.36,0,0,1,10,5a5.47,5.47,0,0,1,.09-1c-4.51,0-4.6.1-4.8.3A1,1,0,0,0,5,5v5.64L1.22,15.38a1,1,0,0,0-.12,1A1,1,0,0,0,2,17h8A1,1,0,0,0,10.9,16.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.78,15.38,27,10.65V5a1,1,0,0,0-1-1H21.91a5.6,5.6,0,0,1,0,2H25v4.64l-3.78,4.73a1,1,0,0,0-.12,1A1,1,0,0,0,22,17h8a1,1,0,0,0,.9-.57A1,1,0,0,0,30.78,15.38Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 25,
    width: 22,
    height: 6,
    rx: 1,
    ry: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,10.45V19h5V10.45a6,6,0,0,1-5,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m21 22a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v1h10z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrity);
export default __webpack_public_path__ + "static/media/integrity.e9b57eb567b8613b4efacb3d64845807.svg";
export { ForwardRef as ReactComponent };